module.exports = __webpack_public_path__ + "media/images/application2/BookingsNew__password__img-b3d3b435cec8605be78ba9b3f10c6d5b.svg";